// src/usePro.js
// React hook that returns the current user's Pro status
import { useState, useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';

export function usePro() {
  const { userId, isLoaded, getToken } = useAuth();
  const [status, setStatus] = useState({ isPro: false, plan: null, loading: true });

  useEffect(() => {
    if (!isLoaded) return;
    if (!userId) {
      setStatus({ isPro: false, plan: null, loading: false });
      return;
    }

    let cancelled = false;
    getToken().then(token => fetch('/api/user-status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({})
    }))
      .then(r => r.json())
      .then(data => {
        if (cancelled) return;
        setStatus({
          isPro: data.isPro || false,
          plan: data.plan || null,
          expiresAt: data.expiresAt,
          loading: false
        });
      })
      .catch(() => {
        if (cancelled) return;
        setStatus({ isPro: false, plan: null, loading: false });
      });

    return () => { cancelled = true; };
  }, [userId, isLoaded, getToken]);

  return status;
}
